export default __webpack_public_path__ + "images/TP.cc9d424.png";